import { ChangeEvent, FC, useState } from 'react';
import {
  Select,
  MenuItem,
  FormControl,
  SelectChangeEvent,
  TextField,
  InputLabel,
} from '@mui/material';
import { ChurnReason } from './types';
import {
  churnReasonsAfterPaywall,
  churnReasonsBeforePaywall,
  needDetailFieldPlaceholderSet,
} from './constants';
import { useTranslation } from 'react-i18next';

interface ChurnReasonDropdownProps {
  where: 'beforePaywall' | 'afterPaywall';
  onSelectReason: (reason: ChurnReason) => void;
}

export const ChurnReasonDropdown: FC<ChurnReasonDropdownProps> = ({ where, onSelectReason }) => {
  const { t } = useTranslation();
  const [reason, setReason] = useState<ChurnReason | null>(null);

  const options = where === 'beforePaywall' ? churnReasonsBeforePaywall : churnReasonsAfterPaywall;

  const shouldShowTextInpupt = Object.keys(needDetailFieldPlaceholderSet).includes(
    reason?.mainReason
  );

  const handleMainReasonChange = (event: SelectChangeEvent<string>) => {
    setReason({
      mainReason: event.target.value,
    });
    onSelectReason({
      mainReason: event.target.value,
    });
  };

  const handleTextChange = (e: ChangeEvent<HTMLInputElement>) => {
    setReason((prev) => ({ ...prev, detailReason: e.target.value }));
    onSelectReason({
      ...reason,
      detailReason: e.target.value,
    });
  };

  return (
    <FormControl fullWidth>
      <InputLabel id="demo-multiple-name-label">{t('settings.churn.selectReason')}</InputLabel>
      <Select
        labelId="churn-reason-label"
        value={reason?.mainReason}
        onChange={handleMainReasonChange}
        label={t('settings.churn.selectReason')}
      >
        {options.map((option) => (
          <MenuItem value={option.value} key={option.value}>
            {t(`settings.churn.reasons.${option.value}`)}
          </MenuItem>
        ))}
      </Select>
      {shouldShowTextInpupt && (
        <TextField
          variant="filled"
          placeholder={t(`settings.churn.placeholders.${reason?.mainReason}`)}
          onChange={handleTextChange}
        />
      )}
    </FormControl>
  );
};
